import { Vector2 } from './Vector2';
import { Component } from './Component';
export class Transform extends Component {
    constructor() {
        super();
        this.position = new Vector2(0, 0);
        this.size = new Vector2(0, 0);
        this.depth = 0;
    }
}
//# sourceMappingURL=Transform.js.map